(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setInitialHeaderBounds();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.handleHomepageIntroComplete = () => {
        this.setHeaderHeight();
        this.setInitialHeaderBounds();
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.onScroll();
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('km:home-intro-complete', this.handleHomepageIntroComplete);

      this.createObserver();
      requestAnimationFrame(() => this.onScroll());
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setInitialHeaderBounds() {
      const rect = this.header.getBoundingClientRect();
      this.headerBounds = {
        top: rect.top + window.pageYOffset,
        bottom: rect.bottom + window.pageYOffset,
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('km:home-intro-complete', this.handleHomepageIntroComplete);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) {
          const rect = entries[0].boundingClientRect;
          this.headerBounds = {
            top: rect.top + window.pageYOffset,
            bottom: rect.bottom + window.pageYOffset,
          };
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    // --- 核心工具函数：处理不同类型的元素开关 ---
    const Utils = {
      // 执行打开
      open: (element) => {
        if (element.tagName === 'DETAILS') {
          // 处理主菜单 (details 标签)
          element.setAttribute('open', 'true');
          const summary = element.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        } else {
          // 处理语言/国家选择器 (div.disclosure 结构)
          const button = element.querySelector('.disclosure__button');
          const list = element.querySelector('.disclosure__list-wrapper');
          if (button) button.setAttribute('aria-expanded', 'true');
          if (list) list.removeAttribute('hidden');
        }
      },
      // 执行关闭
      close: (element) => {
        if (element.tagName === 'DETAILS') {
          element.removeAttribute('open');
          const summary = element.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        } else {
          const button = element.querySelector('.disclosure__button');
          const list = element.querySelector('.disclosure__list-wrapper');
          if (button) button.setAttribute('aria-expanded', 'false');
          if (list) list.setAttribute('hidden', '');
        }
      },
      // 检查是否打开
      isOpen: (element) => {
        if (element.tagName === 'DETAILS') {
          return element.hasAttribute('open');
        } else {
          const list = element.querySelector('.disclosure__list-wrapper');
          return list && !list.hasAttribute('hidden');
        }
      },
    };

    // --- 逻辑构建函数：为一组元素绑定互斥的 Hover 效果 ---
    function initHoverGroup(selector) {
      const groupElements = document.querySelectorAll(selector);

      groupElements.forEach((target) => {
        // 1. 鼠标移入
        target.addEventListener('mouseenter', () => {
          // A. 处理组内其他元素 (互斥逻辑：同一组内只能开一个)
          groupElements.forEach((item) => {
            if (item !== target) {
              // 只要是开着的，立刻关闭，不管有没有倒计时
              if (Utils.isOpen(item)) {
                Utils.close(item);
              }
              // 清除其倒计时
              if (item.dataset.timer) {
                clearTimeout(item.dataset.timer);
                delete item.dataset.timer;
              }
            }
          });

          // B. 处理当前元素
          // 如果当前元素正在倒计时关闭，取消它，保持打开
          if (target.dataset.timer) {
            clearTimeout(target.dataset.timer);
            delete target.dataset.timer;
          }
          // 确保打开
          Utils.open(target);
        });

        // 2. 鼠标移出
        target.addEventListener('mouseleave', () => {
          // 设置 300ms 延迟关闭
          const timerId = setTimeout(() => {
            Utils.close(target);
            delete target.dataset.timer;
          }, 300);

          // 记录 Timer ID
          target.dataset.timer = timerId;
        });
      });
    }

    // --- 初始化两组独立的逻辑 ---

    // 第1组：主菜单 (导航栏)
    initHoverGroup('.header__inline-menu details');

    // 第2组：工具栏 (语言和国家选择器)
    initHoverGroup('.localization-form .disclosure');
  });

  } catch(e) { console.error(e); }
})();
})();
